module.exports = __webpack_public_path__ + "assets/cc9aaf40d77fbd4c4ba361c4687cb3f8.png";